import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
// Self-hosted Inter webfont (replaces the Google Fonts CDN <link>, which could
// not carry a reliable Subresource Integrity hash — Sonar Web:S5725). Weights
// match the former CDN request: 400/500/600/700/800.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import './scss/index.scss';
import { LanguageProvider } from './i18n/LanguageContext.jsx';
import { TenantProvider } from './context/TenantContext.jsx';
import { RuntimeConfigProvider } from './context/RuntimeConfigContext.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <TenantProvider>
        <RuntimeConfigProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </RuntimeConfigProvider>
      </TenantProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register the PWA service worker in production only. In dev the worker's
// cache-first strategy would serve stale JS modules and defeat Vite HMR, so we
// also proactively tear down any worker/cache a previous prod-like load left
// behind on this origin.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    // When a new build's service worker takes control (each deploy stamps a
    // unique cache id into sw.js, so the browser detects the update, installs it
    // via skipWaiting and clients.claim), reload once so open tabs pick up the
    // fresh HTML + hashed assets automatically — no manual hard-refresh. The
    // `reloading` guard prevents a reload loop.
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        // Proactively check for a newer worker on each load.
        reg.update().catch(() => {});
      }).catch(() => {});
    });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    if ('caches' in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}
